// SEO CWV (2026-09-21): los tabs 2..N de featured-products llegan vacíos
// (<template data-remote-tab>) y se traen una sola vez por sección con la
// Section Rendering API, desde la misma página para respetar el idioma.
var _tabsRemotas = {};
function cargarTabsRemotas(sectionId) {
  if (!_tabsRemotas[sectionId]) {
    _tabsRemotas[sectionId] = fetch(window.location.pathname + "?section_id=" + encodeURIComponent(sectionId))
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (t) { return t ? new DOMParser().parseFromString(t, "text/html") : null; })
      .catch(function () { return null; })
      .then(function (doc) { if (!doc) delete _tabsRemotas[sectionId]; return doc; });
  }
  return _tabsRemotas[sectionId];
}

function iniciarSwipers(panel) {
  // Init determinista del swiper del tab recién insertado. El guard
  // swiperInitialized del componente evita doble init.
  panel.querySelectorAll("swiper-component").forEach(function (sc) {
    if (typeof sc.init === "function") {
      try { sc.init(); } catch (e) { /* el observer lo reintentará al ser visible */ }
    }
  });
}

function openTabFeed(evt, sectionId, tabName) {
  const boton = evt.currentTarget;
  // get all elements with class="tabcontent" and hide them except the first one
  const tabcontent = document.getElementsByClassName(
    "products-feed__tabcontent--" + sectionId
  );
  for (let i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }

  // get all elements with class="tablinks" and remove the class "active" except the first one
  const tablinks = document.getElementsByClassName(
    "products-feed__tablinks--" + sectionId
  );
  for (let i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(
      " active",
      ""
    );
  }

  // show the current tab, and add an "active" class to the button that opened the tab
  const panel = document.getElementById(tabName);
  const lazyTpl = panel && panel.querySelector("template.js-lazy-tab");
  if (lazyTpl && lazyTpl.hasAttribute("data-remote-tab")) {
    panel.style.display = "block";
    boton.className += " active";
    panel.setAttribute("aria-busy", "true");
    cargarTabsRemotas(sectionId).then(function (doc) {
      panel.removeAttribute("aria-busy");
      const origen = doc && doc.getElementById(tabName);
      const remoto = origen && origen.querySelector("template.js-lazy-tab");
      const vivo = panel.querySelector("template.js-lazy-tab[data-remote-tab]");
      if (remoto && vivo) {
        vivo.replaceWith(document.importNode(remoto.content, true));
        iniciarSwipers(panel);
      }
    });
    return;
  }
  // SEO CWV C1: instanciar el tab perezoso (contenido en <template>) al primer clic.
  // Al insertar el <swiper-component> en el DOM, su custom element se auto-inicializa.
  if (lazyTpl) {
    lazyTpl.replaceWith(lazyTpl.content.cloneNode(true));
    iniciarSwipers(panel);
  }
  panel.style.display = "block";
  boton.className += " active";
}

// show the first tabs by default on load - data-default-open
document.querySelectorAll("[data-default-open]").forEach(el => {
  el.click();
});
window.addEventListener("shopify:section:load", () => {
  document.querySelectorAll("[data-default-open]").forEach(el => {
    el.click();
  });
});

// Adelantar la descarga de los tabs cuando la página ya cargó (no compite con el LCP).
window.addEventListener("load", function () {
  setTimeout(function () {
    document.querySelectorAll("[data-section-id]").forEach(function (sec) {
      if (sec.querySelector("template.js-lazy-tab[data-remote-tab]")) cargarTabsRemotas(sec.dataset.sectionId);
    });
  }, 1500);
});
